import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '热门韩漫', path: '/category/romance' },
    { label: '最新更新', path: '/' },
    { label: '关于我们', path: '/about' },
  ],
  韩漫分类: categories.slice(0, 6).map((c) => ({
    label: `${c.name}韩漫`,
    path: `/category/${c.slug}`,
  })),
  帮助中心: [
    { label: '阅读指南', path: '/about' },
    { label: '常见问题', path: '/about' },
    { label: '版权声明', path: '/about' },
    { label: '联系我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <span className="font-heading text-2xl font-bold text-primary-400 tracking-tight">
                韩漫
              </span>
              <span className="font-heading text-lg text-background-300">
                网站
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              韩国漫画免费在线阅读平台，下拉式韩漫大全提供高清无删减韩漫全集，为您打造沉浸式韩漫阅读之旅。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm" />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4 tracking-wide">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 韩漫网站 - 韩国漫画免费在线阅读平台，保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}